import { Grid } from "@mui/material";
import InputLabel from "../../../components/Inputs/InputLabel";
import { EscritorioType } from "../../../types/EscritorioType";
import SelectSimple from "../../../components/Selects/SelectSimple";
import { arrayUf } from "../../../data/dataUf";
import { apiSpjUrl } from "../../../services/api";

export default function FormCadEscritorio(info: Partial<EscritorioType>) {
    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <h2 style={{ textAlign: 'center' }} >DADOS ESCRITORIO</h2>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    id="nome_escritorio"
                    label="Nome Escritorio"
                    value={info?.nome_escritorio}
                    setState={() => { }}
                    next="razao_social_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    id="razao_social_escritorio"
                    label="Razão Social Escritorio"
                    value={info?.razao_social_escritorio}
                    setState={() => { }}
                    next="cnpj_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    id="cnpj_escritorio"
                    label="CNPJ Escritorio"
                    value={info?.cnpj_escritorio}
                    setState={() => { }}
                    next="endereco_escritorio"
                    mask="cnpj"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 10 }}>
                <InputLabel
                    id="endereco_escritorio"
                    label="Endereço Escritorio"
                    value={info?.endereco_escritorio}
                    setState={() => { }}
                    next="numero_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }}>
                <InputLabel
                    id="numero_escritorio"
                    label="Numero Escritorio"
                    value={info?.numero_escritorio}
                    setState={() => { }}
                    next="bairro_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    id="bairro_escritorio"
                    label="Bairro Escritorio"
                    value={info?.bairro_escritorio}
                    setState={() => { }}
                    next="cidade_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 1 }}>
                <SelectSimple
                    label="UF"
                    id="uf"
                    value={info?.uf_escritorio || ''}
                    setState={() => { }}
                    options={arrayUf}
                    next="cidade_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    label="Cidade"
                    id="cidade_escritorio"
                    value={info?.cidade_escritorio}
                    next="cep_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
                <InputLabel
                    id="cep_escritorio"
                    label="CEP Escritorio"
                    value={info?.cep_escritorio}
                    setState={() => { }}
                    next="complemento_escritorio"
                    mask="cep"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 5 }}>
                <InputLabel
                    id="complemento_escritorio"
                    label="Complemento"
                    value={info?.complemento_escritorio}
                    setState={() => { }}
                    next="telefone_escritorio"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
                <InputLabel
                    id="telefone_escritorio"
                    label="Telefone Escritorio"
                    value={info?.telefone_escritorio}
                    setState={() => { }}
                    next="email_escritorio"
                    mask="telefone"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
                <InputLabel
                    id="email_escritorio"
                    label="Email Escritorio"
                    value={info?.email_escritorio}
                    setState={() => { }}
                />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
                {info && info.logo_escritorio && (
                    <img src={`${apiSpjUrl}/imguploaded/${info.logo_escritorio}`} height={180} />
                )}
            </Grid>
        </Grid>
    );
}